// src/locales/localesApi.ts
import { apiClient } from "@maat/api-base";
var localesApi = {
  async getLocales() {
    return await apiClient.get("/locales");
  }
};

export {
  localesApi
};
